// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3DkCz","imageUploader":"EGiftCard_imageUploader__397fd"};